import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import style from './styles/style.module.css';

class IconCircleButton extends PureComponent {
    render() {
        const { overlay, backgroundImage } = this.props;

        var inlineStyle = { ...this.props.style };
        if( this.props.size ) {
            inlineStyle.width = inlineStyle.height = this.props.size + 'px';
        }

        var icon = this.props.icon || this.props.label;

        return (
            <button className={ `${ this.props.className } ${ style.iconCircleButton }` }
            style={ inlineStyle } type={ this.props.type } >
                { backgroundImage &&
                    <div className={ style.backgroundImage } style={ { backgroundImage: `url( ${ backgroundImage } )` } }></div>
                }
                { overlay &&
                    <div className={ style.overlayWrapper }>
                        <div className={ style.overlay } data-cover={ overlay }></div>
                    </div>
                }
                { icon &&
                    <div className={ style.icon }>{ icon }</div>
                }
            </button>
        );
    }
}
IconCircleButton.propTypes = {
    className: PropTypes.string,
    type: PropTypes.string,
    icon: PropTypes.oneOfType( [
        PropTypes.string,
        PropTypes.object,
    ] ),
    label: PropTypes.oneOfType( [
        PropTypes.string,
        PropTypes.object,
    ] ),
    style: PropTypes.object,
    size: PropTypes.number,
    overlay: PropTypes.string,
    backgroundImage: PropTypes.string,
};
IconCircleButton.defaultProps = {
    className: '',
    onClick: () => {},
    type: 'button',
};

export default IconCircleButton;
